import axios from 'axios'

export const state = {
  cached: [],
}

export const getters = {}

export const mutations = {
  CACHE_USER(state, newUser) {
    state.cached.push(newUser)
  },
  CLEAR_USERS(state) {
    state.cached = []
  },
}

export const actions = {
  // Destroy action called on logout,
  // along with any other actions named `destroy` in other modules
  destroy({ commit, state, dispatch }) {
    commit('CLEAR_USERS')
  },
  fetchUser({ commit, state, rootState }, { id }) {
    // 1. Check if we already have the user as a current user.
    const { currentUser } = rootState.auth

    if (currentUser && currentUser.user?.user_id === id) {
      return Promise.resolve(currentUser.user)
    }

    // 2. Check if we've already fetched and cached the user.
    const matchedUser = state.cached.find((user) => user.id === id)
    if (matchedUser) {
      return Promise.resolve(matchedUser)
    }

    // 3. Fetch the user from the API and cache it in case
    //    we need it again in the future.
    return axios.get(`/api/v1/users/${id}`).then((response) => {
      const user = response.data
      commit('CACHE_USER', user)
      return user
    })
  },
}
